import { object, number } from "yup";
import { useTranslation } from "react-i18next";

const useProductFormValidationSchema = () => {
  const { t } = useTranslation();
  return object({
    price: number()
      .typeError(t("NUMBER_TYPE_ERROR"))
      .required(t("FIELD_REQUIRED"))
      .min(0),
    priceNet: number().typeError(t("NUMBER_TYPE_ERROR")).nullable(),
    maxSaleQty: number().typeError(t("NUMBER_TYPE_ERROR")).nullable(),
    duration: number().typeError(t("NUMBER_TYPE_ERROR")).nullable(),
    taxClassCode: number().typeError(t("NUMBER_TYPE_ERROR")).nullable(),
  });
};

export { useProductFormValidationSchema };